module.exports = ".active-link {\n    color: black;\n    background-color: lightgrey;\n    text-decoration: none; \n    border:1px solid #aaa;\n    border-radius:5px 5px 0 0;\n    padding: 3px;\n}\n\n.link {\n    text-decoration: none;\n    color: black;\n    padding: 3px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main